import { defineComponent as _defineComponent } from 'vue'
import { MergedCategory } from '@sh/components/Layout/TutorialDropdown';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';

interface Props {
  category: MergedCategory;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoriesCard.ts',
  props: {
    category: null
  },
  emits: ["select"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'select', value: MergedCategory): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emits, OptimizerIconV2 }
}

})